import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component
export default class Logo extends Vue {
  @Getter('companyLogoId', { namespace: 'user' }) companyLogoId

  get hasLogo(): boolean {
    return this.companyLogoId && this.companyLogoId > 0
  }
}

